import { replace } from 'ramda';

const apiDomain = window.APP_CONFIG.apiHost || (process.env.REACT_APP_API_HOST as string);

export const getUrlWithoutDomain = (url: string, domain = apiDomain): string => replace(domain, '', url);

export const getGiftHashFromUrl = (url: string): string => url.split('/').slice(1)[0];
